import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'modelList': [],
  'katashikiList': [],
  'loading': false,
};

export const vehicleQuery = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_VEHICLE_QUERY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_QUERY]: (state, action) => {
      const {type, list} = action.response.data;
      if (type === 'model') {
        return {
          ...state,
          'loading': false,
          'modelList': list,
        };
      }
      return {
        ...state,
        'loading': false,
        'katashikiList': list,
      };
    },
    [ActionTypes.FETCHED_VEHICLE_QUERY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'modelList': [],
      'katashikiList': [],
    }),
    [ActionTypes.CLEAR_VEHICLE_QUERY]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};
